import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';

interface Props {
  children: React.ReactNode;
  open: boolean;
}

function ModalBase({ children, open }: Props) {
  return (
    <Dialog data-testid="modalBase" fullScreen open={open}>
      <Box display="grid" height="100%" justifyContent="center" sx={{ overflow: 'auto' }} width="100%">
        {children}
      </Box>
    </Dialog>
  );
}

export default ModalBase;
